// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_31-1";
export var movingGradient = "_31-4";
export var movingGradientBlock = "_31-2";
export var skeleton = "_31-0";
export var skeletonText = "_31-3";